import React from 'react';
import { T } from '../../../../../../common/locale/translate';

export default class DesktopInfoboxes extends React.Component {
  render() {
    const { infoboxes, selectedIndexDesktop, onClick } = this.props;

    return (
      <div className="desktop-infobox">
        <div className="desktop-titles">
          {infoboxes.map((infobox, index) => (
            <div
              className={`wrapper-title ${
                selectedIndexDesktop === index ? 'selected' : ''
              }`}
              data-image-url={infobox.picture.thumb.url}
              data-retina-url={infobox.picture.retina_thumb.url}
              onClick={() => onClick(index)}
            >
              <p className="category-title">{infobox.title}</p>
            </div>
          ))}
        </div>
        <div className="desktop-images">
          {infoboxes.map((infobox, index) => (
            <div
              className={`category-image desktop-image ${
                selectedIndexDesktop === index ? '' : 'hidden'
              }`}
            >
              <img
                src={infobox.picture.thumb.url}
                srcSet={`${infobox.picture.thumb.url} 1x, ${
                  infobox.picture.retina_thumb.url
                } 2x`}
                alt={infobox.title}
              />
              <figcaption>
                <p className="infobox-description">{infobox.description}</p>
                <a
                  href={infobox.short_url}
                  title={`${T('look_at')} ${infobox.title}`}
                >
                  <p className="infobox-check">{T('check_categorie')}</p>
                </a>
              </figcaption>
            </div>
          ))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/home/components/categories_section/desktop-infoboxes.jsx